
import { defineComponent } from 'vue'
import { iLov } from '../../../LovsManagement'
import { VCodeMirror } from 'vue3-code-mirror'
import Dropdown from 'primevue/dropdown'

export default defineComponent({
    name: 'lovs-management-script',
    components: { Dropdown, VCodeMirror },
    props: {
        selectedLov: { type: Object, required: true },
        selectedScript: { type: Object, required: true },
        listOfScriptTypes: { type: Array }
    },
    emits: ['touched'],
    data() {
        return {
            lov: {} as iLov,
            script: {} as any,
            code: '',
            dirty: false,
            codeMirror: {} as any,
            options: {
                mode: '',
                indentWithTabs: true,
                smartIndent: true,
                lineWrapping: true,
                matchBrackets: true,
                autofocus: true,
                theme: 'eclipse',
                lineNumbers: true
            }
        }
    },
    watch: {
        selectedLov() {
            this.loadLov()
            this.loadSelectedScript()
        }
    },
    computed: {
        lovType(): string {
            return this.selectedLov.itypeCd
        }
    },
    created() {
        this.loadLov()
        this.loadSelectedScript()
        this.setupCodeMirror()
    },
    methods: {
        loadLov() {
            this.lov = this.selectedLov as iLov
        },
        loadSelectedScript() {
            this.script = this.selectedScript as any

            if (this.script) {
                this.code = this.script.text ?? ''
            }
            this.options.mode = this.script.type === 'ECMAScript' ? 'text/javascript' : 'text/x-groovy'
        },
        onKeyUp() {
            this.$emit('touched')
            this.script.text = this.code
        },
        onLanguageChanged(value: string) {
            const mode = value === 'ECMAScript' ? 'text/javascript' : 'text/x-groovy'
            setTimeout(() => {
                this.setupCodeMirror()
                this.codeMirror.setOption('mode', mode)
            }, 250)
            this.$emit('touched')
        },
        setupCodeMirror() {
            if (this.$refs.codeMirror) {
                this.codeMirror = (this.$refs.codeMirror as any).editor as any
            }
        }
    }
})
